import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Alert, Button, Dialog, useMediaQuery} from "@mui/material";
import * as React from "react";

const MakeOpen = ({ openByStatus, handleCloseConfirmation, handleMakeItOpen  }) => {
    const sizeMatch = useMediaQuery('@media (min-width:600px)')

    return (
        <Dialog
            fullScreen={!sizeMatch}
            sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth: '600px', maxHeight: 435 }, padding: 2 }}

            maxWidth="xs"
            open={openByStatus.open ?? !!openByStatus.open }
            onClick={event => event.stopPropagation()}
        >
            <DialogTitle>{"Deseja realmente cancelar a fatura?"}</DialogTitle>
            <DialogContent>

                <Alert  severity="error">
                    Ao cancelar a fatura, o boleto e o QR Code do Pix também serão cancelados, e a fatura será reaberta automaticamente.
                </Alert>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between' }}>
                <Button autoFocus onClick={handleCloseConfirmation}>{"Cancelar"}</Button>
                <Button variant={"contained"} onClick={handleMakeItOpen}>{"Confirmar"}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default MakeOpen